<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  color="#FFAA00"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.15333 2.33977L10.3267 4.68643C10.4269 4.8625 10.5629 5.0156 10.726 5.13583C10.889 5.25606 11.0755 5.34075 11.2733 5.38443L13.4 5.73777C14.76 5.96443 15.08 6.9511 14.1 7.92443L12.4467 9.57777C12.302 9.73996 12.1957 9.93266 12.1357 10.1416C12.0757 10.3504 12.0635 10.5702 12.1 10.7844L12.5733 12.8311C12.9467 14.4511 12.0867 15.0778 10.6533 14.2311L8.66 13.0511C8.45588 12.946 8.2296 12.8911 8 12.8911C7.7704 12.8911 7.54412 12.946 7.34 13.0511L5.34667 14.2311C3.92 15.0778 3.05333 14.4444 3.42667 12.8311L3.9 10.7844C3.93653 10.5702 3.92433 10.3504 3.86432 10.1416C3.8043 9.93266 3.69801 9.73996 3.55333 9.57777L1.9 7.92643C0.926667 6.9531 1.24 5.96643 2.6 5.73977L4.72667 5.38443C4.92334 5.33979 5.10855 5.25467 5.27051 5.1345C5.43247 5.01432 5.56761 4.86172 5.66733 4.68643L6.84067 2.33977C7.48 1.06643 8.52 1.06643 9.15333 2.33977Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
